export const TAB_TYPE = {
  consult: 'consult',
  group: 'group',
  mine: 'mine'
}

export const STUDIO_ID_KEY = 'mp:xltStudioId'
export const LOCATION_KEY = 'mp:xltLatAndLng'
